import { Modal } from "react-bootstrap";

export default function UserReactivateModal({
    show,
    onClose,
    onConfirm,
    selectedUser,
    type,
    isDeleting
}) {

    const getMessage = () => {
        if (type === "deactivate") {
            return `Are you sure you want to deactivate ${selectedUser?.email}?`;
        }
        if (type === "permanentDelete") {
            return `Are you sure you want to permanently delete ${selectedUser?.email}?`;
        }
        if (type === "deny") {
            return `Are you sure you want to deny deactivation request for ${selectedUser?.email}?`;
        }
        if (type === "reactivate") {
            return `Are you sure you want to re-activate ${selectedUser?.email}?`;
        }
    };

    return (
        <Modal
            show={show}
            onHide={isDeleting ? undefined : onClose}
            backdrop={isDeleting ? "static" : true}
            keyboard={!isDeleting}
            className="companyEdit-modal confim-modal add-modal"
        >

            <div className="modal-header pt-2">
                <button
                    className="btn-close text-dark close-button btn-closemodel"
                    onClick={onClose}
                    disabled={isDeleting}
                >
                    &nbsp;
                </button>
            </div>

            <div className="modal-body pb-0">
                <div className="row">
                    <div className="col-md-12 deletetitle">
                        <h4 className="edit-title">{getMessage()}</h4>
                    </div>

                    <div className="row">
                        <div className="col-md-3"></div>

                        <div className="col-md-3 cancelbox">
                            <button className="btn save-btn cancel" onClick={onClose} disabled={isDeleting}>
                                Cancel
                            </button>
                        </div>

                        <div className="col-md-3">
                            <button className="btn save-btn confirm" onClick={onConfirm} disabled={isDeleting}>
                                {isDeleting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Deleting...
                                    </>
                                ) : (
                                    "Confirm"
                                )}
                            </button>
                        </div>

                        <div className="col-md-3"></div>
                    </div>
                </div>
            </div>

        </Modal>
    );
}
